import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css"; // Verhindert FOUC-Probleme (Flash of Unstyled Content)
config.autoAddCss = false;
